<template>
  <v-card
    flat
    outlined
    rounded="lg"
    height="100%"
    color="cardbg"
    class="flex"
    elevation="10"
  >
    <v-card-title
      color="primary"
      :style="`padding: calc(${scale} * 0.4rem);
        line-height: calc(${scale} * 0.75rem);
        font-size: calc(${scale} * 0.7rem);`"
      class="font-weight-medium"
    >
      <span>
        {{ widgettitle }}
      </span>
    </v-card-title>
    <v-card-text
      class="d-flex justify-center"
      style="overflow: hidden; height: 86%; color: #FFFFFF; padding: 0; line-height: normal;"
    >
    <v-window
      v-model="onboarding"
      style="height: 100%; width: 100%; text-align: center;"
    >
      <v-window-item
        v-for="(link, i) in srclinks"
        :key="`item-${i}`"
        style="height: 100%;"
      >
        <img
          alt=""
          :src="link"
          style="height: 100%; max-width: 100%;"
        >
      </v-window-item>
    </v-window>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'QualityFeedback',
  props: {
    widgettitle: { type: String },
    scale: { type: Number, default: 1 },
  },
  data() {
    return {
      srclinks: null,
      loading: true,
      onboarding: 0,
      slidetimeInterval: null,
    };
  },
  computed: {
    ...mapState('cellwiseQualityDashboard', ['slideInterval', 'currentDate']),

    selectedCell() {
      return this.$route.query.selectedcell;
    },
  },
  watch: {

    async selectedCell() {
      await this.fetchData(true);
    },
    async currentDate(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        await this.fetchData();
      }
    },
  },
  async mounted() {
    await this.fetchData(true);
    this.autoslide();
  },
  beforeDestroy() {
    clearInterval(this.slidetimeInterval);
  },
  methods: {
    ...mapActions('cellwiseQualityDashboard', ['getFeedbackImg', 'getFile']),

    async fetchData(loader = false) {
      if (loader) this.loading = true;

      try {
        let query = '?query=widget=="Quality Feedback"';
        if (this.selectedCell) {
          query += `%26%26cellname=="${this.selectedCell}"`;
        }
        query += '&sortquery=createdTimestamp==-1&pagesize=3&pagenumber=1';

        const sops = await this.getFeedbackImg(query);
        const safeSops = Array.isArray(sops) ? sops : [];

        const rawLinks = await Promise.all(
          safeSops.map(async (img) => {
            if (img.downloadlink) {
              const safeUrl = await this.getFile(img.downloadlink);
              return safeUrl;
            }
            return null;
          }),
        );

        this.srclinks = rawLinks.filter((link) => link !== null && link !== false);
      } catch (error) {
        console.error('[QualityFeedback] Error fetching images:', error);
        this.srclinks = [];
      } finally {
        this.loading = false;
      }
    },

    autoslide() {
      clearInterval(this.slidetimeInterval);
      const slideInt = this.slideInterval || 10;
      this.slidetimeInterval = setInterval(() => {
        this.next();
      }, slideInt * 1000);
    },

    next() {
      const len = this.srclinks ? this.srclinks.length : 0;
      if (len > 0) {
        this.onboarding = this.onboarding + 1 === len ? 0 : this.onboarding + 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.w-full {
  width: 100%;
}
.h-full {
  height: 100%;
}
</style>
